import { Injectable } from '@angular/core';
import { PushNotificationsService } from 'ng-push-ivy';
import { Router } from '@angular/router';
import { AndroidInterface } from '../types/all.type';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { log } from '../functions';
import { NotifierWrapService } from './notifier-wrap.service';
import { SnotifyPosition, SnotifyService, SnotifyToast } from 'ng-snotify';
import {InterfaceService} from './interface.service';
import {FixTypePipe} from '../pipes/fixtype.pipe';
declare const electron: any;
declare const Android: AndroidInterface;

export interface NotifyCrossData {
  title: string;
  text: string;
  avatar?: string;
  clickUrl?: string;
  chatId?: string | number;
  chatType?: string;
  path?: string;
  urgency?: 'critical';
  subtitle?: string;
  id?: number;
  sound?: boolean;
  noSound?: boolean;
}
@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  arNotifies: SnotifyToast[] = [];
  desktopMax = 3;
  mobileMax = 1;
  constructor(
    public interfaceService: InterfaceService,
    private snotifyService: SnotifyService,
    public notifierWrapService: NotifierWrapService,
    public router: Router,
    private pushNotifications: PushNotificationsService,
    public fixTypePipe: FixTypePipe
  ) {
    this.pushNotifications.requestPermission();
  }
  closeAll(): void {
    this.arNotifies.forEach((v, index) => {
      v.config.timeout = 1;
      v.eventEmitter.complete();
    });
    this.arNotifies = [];
    this.snotifyService.clear();
    this.interfaceService.detectChangeForNotify();
  }
  closeOld(): void {
    const max = window.innerWidth < 768 ? this.mobileMax : this.desktopMax;
    if (this.arNotifies?.length >= max) {
      // Удаляем старые сообщения
      this.arNotifies[0].config.timeout = 1;
      this.arNotifies[0].eventEmitter.complete();
      this.arNotifies.shift();
    }
    this.interfaceService.detectChangeForNotify();
  }

  push(data: NotifyCrossData, disabled: any[] = []): Observable<any> {
    return new Observable((observer) => {
      if (window.innerWidth < 768) {
        this.snotifyService.config.global.maxOnScreen = this.mobileMax;
        // this.snotifyService.config.global.newOnTop = true;
      } else {
        this.snotifyService.config.global.maxOnScreen = this.desktopMax;
        // this.snotifyService.config.global.newOnTop = false;
      }
      //////
      // const chat = this.allService.arChat.find((v) => v.id === data.chatId);
      if (data?.chatType && data.chatType !== 'private' && this.interfaceService.filterType === 'private') {
        // log('Notification skip filtered');
        return;
      }
      /// log('chat', chat);
      //////
      if (
        document.hasFocus() ||
        !this.pushNotifications.isSupported() ||
        this.pushNotifications.permission !== 'granted'
      ) {
        log('Notification default', this.pushNotifications.permission, this.pushNotifications.isSupported());


        let html = `<div  class="d-flex align-items-center notifyMessage">`;
        html += `<div class="col p-0 notify-left">`;
        html += `<h5 class="text-truncate w-100">${data.title}</h5>`;
        html += `<div class="notify-text">${data.text}</div>`;
        html += `</div>`;

        html += `
                         <div class="col-auto pr-0">
                             <div class="notify-avatar-wrap position-relative">
                                <img class="rounded-circle invert" width="60" src="${
                                    this.fixTypePipe.transform(data.avatar) || '/assets/images/logo.png'
                                }">
                                <img width="40" height="40" class="avatar-type pl-2 invert" src="/assets/icons/socials/${
                                  data.path
                                }.svg">
                             </div>
                         </div>`;
        html += `</div>`;
        let position = SnotifyPosition.leftBottom;
        if (window.innerWidth < 768) {
          position = SnotifyPosition.centerTop;
        }
        this.closeOld();
        this.arNotifies.push(
          this.snotifyService.warning(data.text, {
            timeout: 100000,
            showProgressBar: true,
            position,
            closeOnClick: true,
            pauseOnHover: false,
            animation: { enter: 'fadeIn', exit: 'fadeOut', time: 0 },
            html,
            buttons: [
              {
                text: 'Открыть чат',
                action: (v) => {
                  this.closeAll();
                  observer.next({
                    click_url: data.clickUrl,
                    chatId: data.chatId,
                    path: data.path
                  });
                  observer.complete();
                  /// this.allService.openChat$.next(v.config.titleMaxLength);
                  console.log(v);
                },
                bold: false
              },
              { text: 'Скрыть', action: null, bold: false },
              // TODO отключть уведолмения
              {
                text: 'Скрыть все',
                action: () => {
                  this.snotifyService.clear();
                },
                bold: true
              }
            ]
          })
        );
        //
        /*this.arNotifies = this.snotifyService.simple('', {
                    timeout: 100000,
                    showProgressBar: false,
                    position: position,
                    closeOnClick: false,
                    pauseOnHover: false,
                    animation: {enter: 'fadeIn', exit: 'fadeOut', time: 400},
                    html: '',
                    buttons:  [
                        {text: 'Скрыть все', action: (v) => {
                                this.snotifyService.clear();
                            }, bold: false}
                    ]
                })*/
        try {
          this.notifierWrapService.onMessagePlay();
        }catch (e) {
          console.error(e);
        }
      } else if (electron) {
        log('Notification electron');
        (async () => {
          const blob = await fetch(data.avatar || '/assets/images/logo.png').then((r) => r.blob());
          await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => {
              resolve(reader.result);
              electron.ipcRenderer.send('push.notification', {
                title: data.title,
                body: data.text,
                icon: reader.result,
                silent: !data.noSound,
                urgency: data.urgency || 'critical',
                subtitle: data.subtitle || 'Новое сообщение',
                click_url: data.clickUrl,
                chatId: data.chatId,
                path: data.path,
                renotify: false
              });
            };
            reader.readAsDataURL(blob);
          });
          // now do something with `dataUrl`
        })();
        observer.next({ type: 'electron' });
        observer.complete();
      } else if (typeof Android !== 'undefined') {
        try {
          // Android.showToast(text);
          if (disabled.indexOf('android') === -1) {
            Android.pushNotifications(
              data.id || 0,
              data.text,
              data.title,
              data.text,
              data.title,
              data.path,
              data.avatar,
              data.clickUrl,
              data.chatId
            );
          }
          observer.next({ type: 'android' });
          observer.complete();
        } catch (e) {}
      } else {
        log('Notification native', this.pushNotifications.permission, data);
        this.pushNotifications
          .create(data.title, {
            body: data.text,
            icon: data.avatar,
            // silent: !data.noSound,
            // renotify: true
          })
          .subscribe(
            (res) => {
              if (res.event.type === 'click') {
                log('pushNotifications click', data);
                observer.next(data);
                observer.complete();
              }
            },
            (err) => {
              log(err);
            }
          );
      }
      this.interfaceService.detectChangeForNotify();
    }).pipe(first());
  }
}
